import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PointOfSale from './PointOfSale';
import SalesHistory from './SalesHistory';
import SupplierInvoiceHistory from './SupplierInvoiceHistory';

export default function BillingHub() {
  const [params] = useSearchParams();
  const view = params.get('view');

  return (
    <div className="h-full min-h-0">
      {view === 'history'  ? <SalesHistory />           :
       view === 'invoices' ? <SupplierInvoiceHistory /> :
                             <PointOfSale />}
    </div>
  );
}
